import React, { useEffect, useState } from "react";
import "./Infocustomer.css";

const Infocustomer = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch("/customer", {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((json) => setData(json))
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };

  const deactivateCustomer = (id) => {
    if (!window.confirm("Mark this customer as inactive?")) return;

    fetch(`/customer/${id}/deactivate`, {
      method: "PATCH",
      credentials: "include",
    })
      .then((res) => res.json())
      .then(() => {
        alert("Customer has been deactivated");
        fetchData();
      })
      .catch((err) => console.error("Deactivate failed:", err));
  };

  return (
    <div className="infocustomer-container">
      <h1>Customer Information</h1>
      <table className="infocustomer-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Name</th>
            <th>Company</th>
            <th>Position</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Timezone</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(data) ? (
            data.map((item) => (
              <tr
                key={item.id}
                className={item.is_active === 0 ? "inactive-row" : ""}
              >
                <td>{item.id}</td>
                <td>{item.email}</td>
                <td>{item.name}</td>
                <td>{item.CompanyName}</td>
                <td>{item.position}</td>
                <td>{item.phone}</td>
                <td>{item.address}</td>
                <td>{item.timezone_offset}</td>
                <td>
                  <button
                    className="infocustomer-delete-button"
                    disabled={item.is_active === 0}
                    onClick={() => {
                      if (item.is_active === 1) deactivateCustomer(item.id);
                    }}
                  >
                    {item.is_active === 1 ? "Deactivate" : "Disabled"}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Infocustomer;
